import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./GestionConsultoria.css";
import { FaCheckCircle } from "react-icons/fa";

interface AlcanceItem {
  titulo: string;
  descripcion?: string;
}

interface GestionConsultoriaProps {
  gestion?: any[]; // Defined optionally if needed later
  alcance: AlcanceItem[];
}

export default function GestionConsultoria({ alcance }: GestionConsultoriaProps) {
  const { t } = useTranslation();
  const cajasRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [animadas, setAnimadas] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number((entry.target as HTMLElement).dataset.idx);
            setAnimadas((prev) => {
              if (!prev.includes(idx)) return [...prev, idx];
              return prev;
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 },
    );

    cajasRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [alcance]);

  return (
    <>
      <div className="componente-consultoria">
        <h3>{t("gestion.gestion_title")}</h3>
        <h2>{t("gestion.consultoria_intro")}</h2>
        <div className="contenedor-consultoria"></div>
      </div>

      <div className="componente-consultoria2">
        <h3>{t("gestion.alcance_title")}</h3>
        <div className="contenedor-consultoria2">
          {Array.isArray(alcance) && alcance.map((grupo, idx) => (
            <div className="grupo-consultoria2" key={idx}>
              <div
                className="caja-consultoria2 con-icono-consultoria"
                ref={(el) => { cajasRefs.current[idx] = el; }}
                data-idx={idx}
                style={{
                  animation: animadas.includes(idx)
                    ? "bgMoveData 3s ease-in-out forwards"
                    : "none",
                } as React.CSSProperties}
              >
                <FaCheckCircle className="icono-consultoria" />
                <span className="texto-item">{grupo.titulo}</span>
              </div>
              {grupo.descripcion && (
                <motion.p
                  className="descripcion-consultoria2"
                  initial={{ opacity: 0, y: -20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {grupo.descripcion}
                </motion.p>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
